import { EconomicsSettingBase } from './base/economics-setting-base';

export class EconomicsSetting extends EconomicsSettingBase { }